import {
  parseAsString,
  parseAsArrayOf,
  parseAsBoolean,
  useQueryStates,
} from '@vrplatform/query-params';
import { useTableStoreReset } from '../../../../stores';

export const useExpenseTableFilter = () => {
  const [filter, setFilter] = useQueryStates({
    search: parseAsString,
    listingIds: parseAsArrayOf(parseAsString),
    date: parseAsString,
    accountId: parseAsString,
    contactId: parseAsString,
    paidStatus: parseAsString,
    reconciled: parseAsBoolean,
    connectionId: parseAsString,
    recurring: parseAsString,
  });

  const resetStore = useTableStoreReset();

  const setFilterWithReset = (...args: Parameters<typeof setFilter>) => {
    resetStore();
    return setFilter(...args);
  };

  return {
    filter,
    setFilter: setFilterWithReset,
    reset: () => setFilterWithReset(null),
  };
};
